import { Collapse, Divider, Spin } from "antd";
import {
	ActionButtonComponent,
	EditBannerContainer,
	EditItemsContainer,
} from "./style";
import { BannerMobileItems } from "./constants";
import { UpOutlined } from "@ant-design/icons";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useBannerMobileContext } from "../../context/BannerMobileContext/BannerMobileContext";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

const EditBannerMobile = () => {
	const { id } = useParams<{ id: string }>();
	const { updateBannerMobile, operationStatus, getBannerMobileDetails } = useBannerMobileContext();

	useEffect(() => {
		if (id) {
			getBannerMobileDetails(id);
		}
	}, [id]);

	return (
		<EditBannerContainer>
			<Spin spinning={operationStatus.type === "loading" && operationStatus.operation === "fetch"}>
				<EditItemsContainer>
					<h3>Mobil Banner Güncelle</h3>
					<Divider />
					<Collapse
						items={BannerMobileItems}
						expandIconPosition="end"
						bordered={false}
						expandIcon={({ isActive }) => (
							<UpOutlined rotate={isActive ? 0 : -180} />
						)}
						defaultActiveKey={["1", "2", "3", "4"]}
					/>
					<ActionButtonComponent>
						<MainButtonComponent onClick={updateBannerMobile} type="default" loading={operationStatus.type === "loading" && operationStatus.operation === "update"}>
							Güncelle
						</MainButtonComponent>
					</ActionButtonComponent>
				</EditItemsContainer>
			</Spin>
		</EditBannerContainer>
	);
};

export default EditBannerMobile;
